import styled from "styled-components";
import { Link } from "@mui/material";
import { IThemeProps } from "component/theme";
import Box from "component/layoutComponents/Box";
import EyeBrow1 from "component/MarketPlace/eyeBrow/eyeBrow";
import Row from 'component/layoutComponents/Row';
import { TruncatedText } from "../Typography/Typography.style";

export const StyledSubStageEyeBrow = styled(EyeBrow1)`
${({theme: any}) => `
  .MuiChip-label{
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-word;  
    white-space: unset
  }
`}`;

export const StyledOrderLink = styled(Link)`
  ${({ theme }: IThemeProps) => `
    text-decoration: none !important;
    color: ${theme.uptimeColors.grayScales.darkerGray} !important;
    cursor: pointer;
  `}
`;

export const StyledRowProduct = styled.div`
  ${({ theme }: IThemeProps) => `
    width: 100%;
    display: flex;
    overflow: hidden;
    flex-wrap: wrap;
    gap: ${theme.uptimeSpace[3]}px;
  `}
`;
export const StyledRow = styled(Row)`
  ${({ theme }: IThemeProps) => `
    margin: 0 !important;
  `}
`;


export const StyledProductImage = styled(Box)`
  ${({ theme }: IThemeProps) => `
    display: flex;
    align-items: center;
    margin-right: 4px;

    img{
      object-fit: contain;
      width: 48px;
      height: 48px;
      mix-blend-mode: multiply;
    }
  `}
`;

export const StyledOrderNumber = styled(TruncatedText)`
  ${({ theme }: IThemeProps) => `
    overflow: hidden;
    text-overflow: ellipsis;
    display:-webkit-box;
    -webkit-box-orient: vertical;
    //-webkit-line-clamp: 1;
    margin: 0;    
    word-break: break-word;
  `}
`;

export const StyledOrderItemFooterButton = styled(Box)`
  ${({ theme }: IThemeProps) => `
    cursor: pointer;
  `}
`;

export const StyledOrderCardRightHeader = styled(Box)`
  ${({ theme }: IThemeProps) => `
  @media(min-width: 0px){
    display: none;
  }
  @media(min-width: 600px){
    display: flex;
  }
      ul[role="menu"]{
        background: ${theme.uptimeColors.grayScales.white};
        box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        width: 128px;
        height: 88px;
        flex-direction: column;
        top: 32px;
        left: unset;
        right: 0;
        display: flex;
        border: none;
        @media(max-width: 900px){
          flex-direction: column;
          height: unset;
        }
        button[role="menuitem"]{
          width: 100%;
          color: ${theme.uptimeColors.grayScales.black};;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0.4px;
          &:hover{
            background: transparent;
            text-decoration: underline;
          }
          @media(max-width: 900px){
            &:first-child{
              color: ${theme.uptimeColors.grayScales.darkestGray};
              border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            }
          }
        }
      }
  `}
`;
export const StyledCardItems = styled(Box)(({ theme }: IThemeProps) => `
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: ${theme.uptimeSpace[2]}px;
  display:flex;
  align-items: center;
  justify-content: center;
  width: 97.6px;
  height: 64px;
`);
export const StyledCardContent = styled(Box)(({ theme }: IThemeProps) => `
  display: flex;
  background-color: ${theme.uptimeColors.grayScales.grayish};
  height: 96px;
  padding: ${theme.uptimeSpace[8]}px;
  width: 100%;
`);